// src/MessageList.js
import React from 'react';
import MessageItem from './MessageItem'; // Importer MessageItem

function MessageList({ messages }) {
  if (!messages || messages.length === 0) {
    return <p>Ingen meldinger ennå.</p>;
  }

  return (
    <div className="message-list-container" style={{maxWidth: '500px', margin: '0 auto'}}> {/* Litt breddebegrensning */}
      {messages.map(msg => (
        <MessageItem key={msg.id} message={msg} /> // Bruk MessageItem her
      ))}
    </div>
  );
}

export default MessageList;